import { Box, Table, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import DocumentType from 'modules/core/components/DocumentType'
import i18n from 'modules/core/lib/i18n'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import Actions from './Actions'

interface Props {
  clockPicture: ClockPicture
  employeeFullName: string
}

const Item = ({ clockPicture, employeeFullName }: Props) => {
  const AvatarCell = () => {
    const mimeType = clockPicture.attributes.content_type
    return <Box paddingRight="s16">{mimeType && <DocumentType mimetype={mimeType} />}</Box>
  }

  return (
    <Table.Row>
      <Table.Cell>
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          width="full"
          padding="s8"
        >
          <Box alignItems="center" flexGrow flexDirection="row">
            <AvatarCell />
            <Box paddingRight="s16" overflowX="hidden">
              <Text.Normal weight="medium" ellipsis>
                {clockPicture.attributes.filename}
              </Text.Normal>
              <Box paddingTop="s4">
                <Text.Normal size="200" color="grey600">
                  {clockPicture.description}
                </Text.Normal>
              </Box>
            </Box>
          </Box>
          <Box flexDirection="row" alignItems="center" gap="s16">
            {clockPicture.isInvalid && (
              <Tag type="radical">
                {i18n.t('time_tracking.settings.face_recognition.logs.invalid')}
              </Tag>
            )}
            <Actions clockPicture={clockPicture} employeeFullName={employeeFullName} />
          </Box>
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default observer(Item)
